import {
    FETCH_USER_SUMMARY_AVERAGES_FAIL,
    FETCH_USER_SUMMARY_AVERAGES_FETCHING,
    FETCH_USER_SUMMARY_AVERAGES_SUCCESS
} from '../../actions/userSummaryActions';

const userSummaryAveragesFetching = (state) => {
    return {
        ...state,
        userSummaryAveragesFetching: true,
        userSummaryAveragesFetchFail: false
    };
};

const userSummaryAveragesCompleted = (isSuccess) => (state, action) => {
    return {
        ...state,
        userSummaryAverages: action.userSummaryAverages || {},
        userSummaryAveragesFetching: false,
        userSummaryAveragesFetchFail: !isSuccess
    };
};

export const isUserSummaryAveragesFetching = (state) => {
    return state.userSummaryAverages.userSummaryAveragesFetching;
};

export const isUserSummaryAveragesFetchFail = (state) => {
    return state.userSummaryAverages.userSummaryAveragesFetchFail;
};

export const getUserSummaryAverages = (state) => {
    return state.userSummaryAverages.userSummaryAverages;
};

const handlers = {
    [FETCH_USER_SUMMARY_AVERAGES_FETCHING]: userSummaryAveragesFetching,
    [FETCH_USER_SUMMARY_AVERAGES_SUCCESS]: userSummaryAveragesCompleted(true),
    [FETCH_USER_SUMMARY_AVERAGES_FAIL]: userSummaryAveragesCompleted(false)
};

export default function userSettings(state = {}, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
